module.exports = __webpack_public_path__ + "static/media/leaves-bw.2febd023.png";